/**
 * Returns all the properties from the conceptual model as a map indexed by
 * PIM iri.
 * @param conceptual Conceptual model
 */
export function buildPropertyMap(conceptual) {
    const result = {};
    for (const entity of Object.values(conceptual.classes)) {
        for (const property of entity.properties) {
            if (!result[property.pimIri]) {
                result[property.pimIri] = [null, null];
            }
            result[property.pimIri][property.isReverse ? 1 : 0] = property;
        }
    }
    return (property, isReverse) => result[property]?.[isReverse ? 1 : 0] ?? null;
}
//# sourceMappingURL=utils.js.map